import { ScheduleInput } from '../features/offerModal/types';

/**
 * Determines the status to send to the API based on if there is a schedule involved or not.
 *
 * @param schedule - The schedule from the offer form
 * @returns The status to send to the API:
 *   - undefined: When a schedule is involved (existing or new), scheduler manages status
 *   - 'active': When no schedule is involved, or when transitioning from a scheduled offer to a non-scheduled offer
 */
export const determineOfferStatus = (schedule: ScheduleInput | undefined | null): 'active' | undefined => {
  // Schedule is being set or updated — let the scheduler manage status
  if (schedule) {
    return undefined;
  }

  // No schedule — either removing an existing one or never had one — set to active
  return 'active';
};

/**
 * Determines the optimistic isEnabled value for cache updates based on status.
 *
 * @param status - The status returned from determineOfferStatus
 * @param currentIsEnabled - The current isEnabled value from the taker market
 * @returns The isEnabled value to use in optimistic updates:
 *   - Current value: When status is undefined (scheduler controls it)
 *   - true: When status is 'active' (no schedule, immediately active)
 */
export const determineOptimisticIsEnabled = (status: 'active' | undefined, currentIsEnabled: boolean): boolean => {
  // If status is undefined, scheduler controls it - keep current value
  if (status === undefined) {
    return currentIsEnabled;
  }

  // Status is 'active' - immediately enabled
  return true;
};
